<template>
  <div class="prm-new" v-loading="pageloading">
    <main-head>
      <template v-slot:pageName>
        {{ $t("page.prmEdit.title") }}
      </template>
      <template v-slot:headBtn>
        <el-button type="primary" size="medium" @click="toList">{{ $t('common.preReturnBtn') }}</el-button>
      </template>
    </main-head>
    <main-content>
      <template v-slot:contentArea>
        <div class="form">
          <el-form ref="prmForm" :model="form" :rules="prmRule">
            <el-row :gutter="20" style="margin: 25px 0 25px">
              <el-col :span="24">
                <div class="title">
                  {{ $t('page.prmDetail.contentTitle') }}
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.country')" prop="areaCode">
                  <el-select
                    ref="areaCode"
                    v-model="form.areaCode"
                    :placeholder="$t('message.select')"
                    filterable
                  >
                    <el-option
                      v-for="item in allCountries"
                      :key="item.areaCode"
                      :label="item.areaName"
                      :value="item.areaCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.ruijieSaleName')" prop="ruijieSaleName">
                  <el-input ref="ruijieSaleName" v-model="form.ruijieSaleName" disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.projectName')" prop="projectName">
                  <el-input ref="projectName" v-model="form.projectName" maxlength="500" show-word-limit :disabled="EditFields&&isShow" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="false">
                <el-form-item :label="$t('page.prmNew.fundsInPlace')" prop="fundsInPlace">
                  <el-select ref="fundsInPlace" v-model="form.fundsInPlace" :placeholder="$t('message.select')" @change="fundsInPlaceChange">
                    <el-option
                      v-for="item in fundsInPlaceList"
                      :key="item.dataValue"
                      :label="item.languageValue"
                      :value="item.dataValue"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.expectedOrderDate')" prop="expectedOrderDate">
                  <el-date-picker ref="expectedOrderDate" style="width: 100%" v-model="form.expectedOrderDate" type="date"
                                  value-format="yyyy-MM-dd" :picker-options="pickerOptions"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('page.prmNew.budgetFrom')" prop="budgetFrom">
                  <el-input v-model="form.budgetFrom" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8" v-if="false">
                <el-form-item :label="$t('page.prmNew.projectBudget')" prop="projectBudget">
                  <el-input ref="projectBudget" v-model="form.projectBudget" @change="projectBudgetChange"
                            style="width:calc(100% - 40px);resize:none; float: left" maxlength="500"
                  />
                  <span style="float: right; width: 40px;">&nbsp;&nbsp;{{ $t('message.unitOfCash') }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.networkBudget')" prop="networkBudget">
                  <el-input ref="networkBudget" v-model="form.networkBudget" @change="networkBudgetChange" style="width:calc(100% - 40px);resize:none; float: left" @input="handleInput" maxlength="12" />
                  <span style="float: right; width: 40px;">&nbsp;&nbsp;{{ $t("message.unitOfCash") }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.projectPhase')" prop="projectPhase">
                  <el-select v-model="form.projectPhase" :placeholder="$t('message.select')"
                             @change="projectPhaseChange" style="width:calc(100% - 40px);resize:none; float: left"
                  >
                    <el-option
                      v-for="(item, index) in projectPhaseList"
                      :key="index"
                      :label="item.languageValue"
                      :value="item.languageKey"
                    />
                  </el-select>
                  <span style="float: right; width: 40px;">
                    <el-popover
                      placement="top-start"
                      title="Remarks："
                      width="580"
                      trigger="hover"
                    >
                      <project-phase-desc />
                      <img slot="reference" src="../../assets/question_mark.png" style="margin-left: 5px; margin-top: 5px" alt>
                    </el-popover>
                  </span>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.projectProgressUpdate')" prop="projectProgressUpdate">
                  <el-input ref="projectProgressUpdate" v-model="form.projectProgressUpdate" maxlength="500" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('page.prmNew.projectRequirements')" prop="projectRequirements">
                  <el-input v-model="form.projectRequirements" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24" v-if="false">
                <el-form-item :label="$t('page.prmNew.competitorSituation')" prop="competitorSituation">
                  <el-input v-model="form.competitorSituation" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin: 25px 0 25px">
              <el-col :span="24">
                <div class="title">
                  {{ $t('page.prmDetail.endUserInfo') }}
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalCompanyName')" prop="finalCompanyName">
                  <el-input ref="finalCompanyName" v-model="form.finalCompanyName" maxlength="500" show-word-limit disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalCompanyAddress')" prop="finalCompanyAddress">
                  <el-input ref="finalCompanyAddress" v-model="form.finalCompanyAddress" maxlength="500" show-word-limit :disabled="EditFields&&isShow" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmList.taxNumber')" prop="BrazilianTaxNumbers">
                  <el-popover
                    placement="top-start"
                    title="Remarks："
                    width="580"
                    trigger="hover"
                  >
                    <div><tax-id-description /></div>
                    <!-- <tax-id-description /> -->
                    <!-- TaxIdDescription -->
                    <img slot="reference" src="../../assets/question_mark.png" style="margin-left: 5px; margin-top: 5px" alt>
                  </el-popover>
                  <el-input ref="taxNumber" v-model="form.taxNumber" maxlength="500" />
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="false">
                <el-form-item :label="$t('page.prmNew.jointVisit')" prop="jointVisit">
                  <el-select v-model="form.jointVisit" :placeholder="$t('message.select')"
                             @change="jointVisitChange"
                  >
                    <el-option
                      v-for="item in jointVisitList"
                      :key="item.dataValue"
                      :label="item.languageValue"
                      :value="item.dataValue"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalUserName')" prop="finalUserName">
                  <el-input ref="finalUserName" v-model="form.finalUserName" maxlength="500" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalUserPosition')" prop="finalUserPosition">
                  <el-input ref="finalUserPosition" v-model="form.finalUserPosition" maxlength="500" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalUserTel')" prop="finalUserTel">
                  <el-input v-model="form.finalUserTel" maxlength="500" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.finalUserEmail')" prop="finalUserEmail">
                  <el-input v-model="form.finalUserEmail" maxlength="500" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.isSupportRuijie')" prop="isSupportRuijie">
                  <el-select ref="isSupportRuijie" v-model="form.isSupportRuijie" :placeholder="$t('message.select')" @change="isSupportRuijieChange">
                    <el-option
                      v-for="item in isSupportRuijieList"
                      :key="item.dataValue"
                      :label="item.languageValue"
                      :value="item.dataValue"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.hasCooperated')" prop="hasCooperated">
                  <el-select v-model="form.hasCooperated" :placeholder="$t('message.select')" @change="hasCooperatedChange">
                    <el-option
                      v-for="item in hasCooperatedList"
                      :key="item.dataValue"
                      :label="item.languageValue"
                      :value="item.dataValue"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="false">
                <el-form-item :label="$t('page.prmNew.executiveDepartment')" prop="executiveDepartment">
                  <el-input v-model="form.executiveDepartment" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="false">
              <el-col :span="24">
                <el-form-item :label="$t('page.prmNew.participatingDepartment')" prop="participatingDepartment">
                  <el-input v-model="form.participatingDepartment" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="false">
              <el-col :span="24">
                <el-form-item :label="$t('page.prmNew.dockingPeople')" prop="dockingPeople">
                  <el-input v-model="form.dockingPeople" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('page.prmNew.beforeSell')" prop="beforeSell">
                  <el-input v-model="form.beforeSell" type="textarea" :rows="4" maxlength="2000" show-word-limit />
                </el-form-item>
              </el-col>
            </el-row>
            <!--PartnerInfo-->
            <el-row :gutter="20" style="margin: 25px 0 25px">
              <el-col :span="24">
                <div class="title">
                  {{ $t('page.prmDetail.partnerInfo') }}
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.partnerName')" prop="partnerName">
                  <el-input v-model="form.partnerName" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.partnerEmail')" prop="partnerEmail">
                  <el-input v-model="form.partnerEmail" maxlength="500" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.partnerContactName')" prop="partnerContactName">
                  <el-input v-model="form.partnerContactName" maxlength="500" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.partnerPhone')" prop="partnerPhone">
                  <el-input v-model="form.partnerPhone" maxlength="500" />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item :label="$t('page.prmNew.projectContractor')" prop="projectContractor">
                  <el-input v-model="form.projectContractor" maxlength="500" show-word-limit />
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item :label="$t('Related Tier-2 Partner')" prop="projectContractor">
                  <el-select
                    v-model="form.twoPartnerName"
                    placeholder=""
                    clearable
                    filterable
                    style="width: 100%"
                    default-first-option
                    @change="handleRelatedChange"
                    @input.native="handleRelatedInput"
                    @clear="handleSelectClear"
                  >
                    <el-option
                      v-for="(item, index) in twoPartnerList"
                      :key="index"
                      :label="item.companyName"
                      :value="item.companyCode"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!--附件-->
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('page.prmNew.projectAttachment')" prop="projectAttachment" />
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-upload
                    class="upload-demo"
                    name="file"
                    :http-request="handleUpload"
                    action=""
                    :limit="9"
                    :show-file-list="false"
                  >
                    <el-button size="small" type="primary">{{ $t("common.upload") }}</el-button>
                    <div slot="tip" class="el-upload__tip">{{ $t("common.uploadtip") }}</div>
                  </el-upload>
                  <div v-for="item in attachment" :key="item.areaCode">
                    <el-alert
                      @close="cancelFile(item.id)"
                      type="success"
                    >
                      <a class="filetext"
                         href="javascript:void(0)"
                         v-if="item!=null && item.name!=null"
                         @click="downloadUpload(item.attachmentUrl)"
                      >{{ item.name }}</a>
                    </el-alert>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="btn" style="margin-top: 30px;">
            <el-button @click="clickSaveDraft" v-if="form.status===0" :disabled="draftBtnDisabled">{{ $t("common.saveDraft") }}</el-button>
            <el-button @click="clickSave" v-else :disabled="saveBtnDisabled">{{ $t("common.save") }}</el-button>
            <el-button type="primary" @click="clickSubmit">{{ $t("common.submit") }}</el-button>
          </div>
        </div>
      </template>
    </main-content>
  </div>
</template>

<script>
import PRM from '../../script/prm';
import API from '../../API';
import { parseTime } from '../../libs/util';
import { moneyFormat } from '../../script/utils';
import ProjectPhaseDesc from './ProjectPhaseDesc.vue';
import TaxIdDescription from './TaxIdDescription';
export default {
  name: 'PrmEdit',
  components: { ProjectPhaseDesc, TaxIdDescription },
  mixins: [PRM],
  methods: {
    init () {
      this.isShow = !this.$route.query.isShow;
      let id = this.$route.query.objectId;
      if (id) {
        let that = this;
        API.axios.all([
          API.getPrmSelectData(that.language),
          API.getProBaseInfo(id)
        ]).then(API.axios.spread((first, second) => {
          let json1 = first.data;
          if (json1.status === '200') {
            // console.log(1111);
            // console.log(json1.data, 88888);
            that.fundsInPlaceList = json1.data.fundsInPlaceData;
            that.isSupportRuijieList = json1.data.isSupportRuijieData;
            that.hasCooperatedList = json1.data.yorNData;
            that.projectPhaseList = json1.data.projectPhaseData;
            that.jointVisitList = json1.data.jointVisitData;
          }
          let json2 = second.data;
          if (json2.status === '200') {
            that.form = json2.data;
            that.attachment = json2.data.attachment;
            if (json2.data.expectedOrderDate) {
              that.form.expectedOrderDate = parseTime(json2.data.expectedOrderDate, '{y}-{m}-{d}');
            }
            if (json2.data.projectBudget) {
              that.form.projectBudget = moneyFormat(json2.data.projectBudget);
            }
            if (json2.data.networkBudget) {
              that.form.networkBudget = moneyFormat(json2.data.networkBudget);
            }
            that.canSubmit = json2.data.canSubmit;
            // 基础表存储的值不是String的(下拉数据值统一是String类型)，转为String类型
            if (json2.data.fundsInPlace) {
              that.form.fundsInPlace = json2.data.fundsInPlace.toString();
            }
            if (json2.data.isSupportRuijie) {
              that.form.isSupportRuijie = json2.data.isSupportRuijie.toString();
            }
            if (json2.data.hasCooperated || json2.data.hasCooperated === 0) {
              that.form.hasCooperated = json2.data.hasCooperated.toString();
              console.log(that.form.hasCooperated);
            }
            if (json2.data.projectPhase) {
              that.form.projectPhase = json2.data.projectPhase.toString();
            }
            if (json2.data.jointVisit) {
              that.form.jointVisit = json2.data.jointVisit.toString();
            }
          }
        })).catch((e) => {
          console.log(e);
        });
        API.getAttachmentById(id, this.uploadData.type).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.attachmentId = json.data.id;
            this.attachmentName = json.data.name;
          }
        }).catch(e => {
          console.log(e);
        });
        API.getIsEditUsers().then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.EditFields = !json.data;
            // console.log(this.EditFields);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      this.getPartnerDetail();
    }
  },
  mounted () {
    this.init();
    console.log(this.attachment, 99999);
  }
};
</script>

<style lang="scss" scoped>
.prm-new{
  .el-select{
    width: 100%;
  }
  .add-product{
    .f-l{
      float: left;
    }
    .f-r{
      float: right;
    }
    .clear{
      clear: both;
    }
  }
  .table{
    margin: 20px 0;
  }
}
.div-inline{ display:inline}
.filetext {
  cursor: pointer;
  color: #0087ff;
}

.filetext:hover {
  color: #0087ff;
}

.title{
  color: #303133;
  font-size: 16px;
  padding-left: 30px;
  background: url("../../assets/images/redsquare.png") center left no-repeat;
}
.el-alert--success.is-light{
  height: 35px;
  margin-top: 5px;
}
</style>
